import React from "react";
import "../scss/books.scss";
import "../scss/desktopbooks.scss";

const GhostBotAvatar = (props) => {

  return <div className="ghost"></div>;
};

export default GhostBotAvatar;
